import React from 'react';
import '../../styles/SubIDChangeDrop.css';
import SubIDChanger from "./SubscriberIDChanger";
import {read} from 'xlsx';
import Autocomplete from "@mui/material/Autocomplete";
import {GlobalConstants} from "../../globals/GlobalConstants";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

function FilesDragAndDrop() {
    //State is used here to manipulate what is displayed by the UI while dragging a file and what renders in response to the drop
    const [dragging, setDragging] = React.useState(false);
    const [excelSubs , setSubs] = React.useState({});
    const [currentDB, setCurrentDB] = React.useState("MidAmericanTest2");

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    //Values used for detecting hover state and applying effects as needed
    const drop = React.useRef<any>(null);
    const drag = React.useRef(null);

    let text : string = "";
    //we call use effect to allow responses from external factors-in this case the file being dragged
    React.useEffect(() => {

        //Stops default when dragging file
        const handleDragOver = (e: any) => {
            e.preventDefault();
            e.stopPropagation();
        };

        //When dropping a file this updates the state for UI rendering, checks for file data, and sends if found
        //Should add file type validation here, will do later
        const handleDrop = async (e: any) => {
            e.preventDefault();
            e.stopPropagation();

            setDragging(false);

                const rawFiles = await e.dataTransfer.files[0];
                const files = await rawFiles.arrayBuffer();
                const fileName = await rawFiles.name;
                //console.log(files);
                //console.log(e.dataTransfer.files[0]);

                if(await rawFiles.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    const wb: any = read(files, {sheetStubs: true});

                    //on grabbing a file from drag and drop trim the .xlsx from the name and store it
                    wb.FileName = fileName.substring(0, fileName.length - 5).toUpperCase();
                    //console.log(files, "UPLOAD");
                    //use state to set the data variable and trigger a rerender so the formatter fires again with the new data. Split apart to reduce unnecessary rendering
                    if(wb.Sheets.SubIDs){
                        setSubs(wb);
                    }

                }
                else if (await rawFiles.type === "text/plain"){
                    const reader = new FileReader()
                    reader.onload = async (e) => {
                        if(e.target){
                            text += (e.target.result);
                            console.log(text);
                        }
                    }
                    reader.readAsText(rawFiles);
                }
        };

        //changes UI when dragging file over
        const handleDragEnter = (e: any) => {
            e.preventDefault();
            e.stopPropagation();

            setDragging(true);
        };

        //opposite of above, resets when dragging away from drop area
        const handleDragLeave = (e: any) => {
            e.preventDefault();
            e.stopPropagation();

            if (e.target === drag.current) {
                setDragging(false);
            }
        };

        //setting event listeners
        drop?.current?.addEventListener('dragover', handleDragOver);
        drop?.current?.addEventListener('drop', handleDrop);
        drop?.current?.addEventListener('dragenter', handleDragEnter);
        drop?.current?.addEventListener('dragleave', handleDragLeave);

        return () => {
            drop?.current?.removeEventListener('dragover', handleDragOver);
            drop?.current?.removeEventListener('drop', handleDrop);
            drop?.current?.removeEventListener('dragenter', handleDragEnter);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            drop?.current?.removeEventListener('dragleave', handleDragLeave);
        };
    }, []);

    //return only has hover layout, default is below and displays conditionally based on state to avoid overlapping
    return (
        <div ref={drop}>
            {dragging && (
                <div ref={drag} className='subIDChangeDrop__placeholder'>
                    <span>
                        -- Caution --
                    </span>
                    <span>
                        This Cannot Be Undone!
                    </span>
                    <span
                        role='img'
                        aria-label='emoji'
                        className='subChangearea__icon'
                    >
                        &#9888;
                    </span>
                </div>
            )}
            {!dragging ? <DefaultArea/> : null}
            <Stack spacing={5} direction="row" className="subIDChangeDropButtonBar">
                <Autocomplete
                    className="dbSelect"
                    size={"small"}
                    disablePortal
                    disableClearable
                    options={GlobalConstants.VBA_DB}
                    sx={{width: 150}}
                    defaultValue={GlobalConstants.VBA_DB[0]}
                    renderInput={(params) => <TextField {...params}  />}
                    onChange={onDBChange}
                />
            </Stack>
            <SubIDChanger excelData={excelSubs} currentDB={currentDB}></SubIDChanger>
        </div>
    );
}

export default React.memo(FilesDragAndDrop);

//Regular no hover display
const DefaultArea = () => {
    return (
        <div id="defaultArea" className='subIDChangeDrop__area'>
            <span>
            Drag And Drop Subscriber ID Change Files
            </span>
            <span
                role='img'
                aria-label='emoji'
                className='subChangearea__icon'
            >
                &#128199;
            </span>
        </div>

    )
}